import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { LocalStorageService } from '../../../services/base/local-storage.service';

@Component({
  selector: 'fury-toolbar-darkmode-toggle',
  templateUrl: './toolbar-darkmode-toggle.component.html',
  styleUrls: ['./toolbar-darkmode-toggle.component.scss']
})
export class ToolbarDarkmodeToggleComponent implements OnInit {

  oldLogo: string = null;

  constructor(@Inject(DOCUMENT) private document: Document,
              private localStorageService: LocalStorageService) {
  }

  ngOnInit(): void {
    const darkModeEnabled = this.localStorageService.get('dark-mode');

    if (darkModeEnabled !== null) {
      if (darkModeEnabled) {
        this.toggle();
      }
    }
  }

  toggle(): void {
    const classList: DOMTokenList = this.document.body.classList,
      logo: HTMLImageElement = document.getElementById('logo') as HTMLImageElement;

    if (classList.contains('fury-dark')) {
      classList.remove('fury-dark');
      classList.add('fury-default');
      logo.src = this.oldLogo;
      this.localStorageService.delete('dark-mode');
    } else {
      classList.remove('fury-default');
      classList.add('fury-dark');
      this.oldLogo = logo.src;
      logo.src = 'assets/img/logo-darkmode.png';
      this.localStorageService.set('dark-mode', 1);
    }
  }
}
